import * as zod from 'zod';

import { CartesianPose } from '@sb/geometry';

export default zod.object({
  recordingId: zod.string().nullable().default(null),
  completedCount: zod.number().int().nonnegative().default(0),
  // World pose the embedded Reference Locate Skill resolved this run; the
  // path/sphere visualizers anchor on it (sphere AT this pose, path shifted
  // by live − recorded reference).
  liveReferencePose: CartesianPose.nullable().default(null),
});
